import { render, staticRenderFns } from "./ConfigOverLimitView.vue?vue&type=template&id=b894f394&"
import script from "./ConfigOverLimitView.vue?vue&type=script&lang=js&"
export * from "./ConfigOverLimitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports